/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["span.green_dot[_ngcontent-%COMP%]{width:7px;border-radius:10px;height:7px;display:inline-block;background:#8ccd8b;position:absolute;top:0;bottom:0;margin:auto;left:0}span.red_dot[_ngcontent-%COMP%]{width:7px;border-radius:10px;height:7px;display:inline-block;background:#d73925;position:absolute;top:0;bottom:0;margin:auto;left:0}#location_des[_ngcontent-%COMP%]   .modal-dialog.modal-md[_ngcontent-%COMP%]{max-width:460px}.modal-dialog.PlaceMachine_modal[_ngcontent-%COMP%]{max-width:360px}\n/*# sourceMappingURL=place-machine.component.css.map*/"];
export { styles as styles };
